import React, {useEffect, useState} from 'react';
import {getCreditorApi} from "../../Services/Services";
import {HomeHeader} from "../../Components";
import "./Creditor.scss";
import {numberWithCommas} from "../../Services";
import { Spin } from 'antd';
import {changeCreditorStatus_api} from "./CreditorService";


function CreditorCard({item,refetch}) {

    const [spin,set_spin] = useState(false)

    const pay = async(id)=>{
        set_spin(true)
        try{
            const res =await changeCreditorStatus_api(id)
            refetch()
            set_spin(false)

        }catch (e) {
            set_spin(false)
            console.error(e)
        }
    }

    return(
        <Spin spinning={spin}>
            <div className="creditor-item">
                <div className="creditor-item-name">
                    <span>{`${item.user?.full_name}`}</span>
                </div>

                <div className="creditor-item-price">
                    <span>  {numberWithCommas(item.amount)} تومان </span>
                </div>

                <div className="creditor-item-btn" onClick={e=>pay(item.uid)}>
                    <span>پرداخت</span>
                </div>
            </div>
        </Spin>
    )
}

function Creditor (){


    const mock = [
        {firstName: 'سعید', lastName: 'صمیمی',price:'340000',uid:1},
        {firstName: 'ماجد', lastName: 'باقری',price:'768888',uid:2},
        {firstName: 'سارا', lastName: 'وطنی',price:'32800',uid:3},
    ]

    const [list,set_list] = useState([])



    useEffect(()=>{
        getCreate()
    },[])


    const getCreate = async()=>{
        try{
            const res = await getCreditorApi()
             set_list(res.data.results)
        }catch (e) {
            console.error(e)
        }
    }




    return(
        <div className="creditor-container">
            <HomeHeader/>
            <div className="creditor-list">
                {list.map(m=>{
                    return(
                        <CreditorCard item={m} refetch={getCreate}/>
                    )
                })}
            </div>
        </div>
    )
}

export default Creditor
